import type { AnalyticsDriver } from '../../driver.types';

function pushToDataLayer(event: string, data: Record<string, unknown>): void {
	if (!event) return;
	if (typeof window === 'undefined') return;
	if (!window.dataLayer) window.dataLayer = [];

	window.dataLayer.push({ ...data, event, eventTimeout: 1_500 });
}

export const GoogleTagManagerDriver: AnalyticsDriver = {
	push: (eventName: string, payload: Record<string, unknown>) => {
		pushToDataLayer(eventName, payload);
	},
};
